exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2xCWFp3KMGquS7PLDiYcOX{vertical-align:text-top}html[dir=ltr] ._2xCWFp3KMGquS7PLDiYcOX{padding-left:2px}html[dir=rtl] ._2xCWFp3KMGquS7PLDiYcOX{padding-right:2px}", ""]);

// exports
exports.locals = {
	"linkSpinner": "_2xCWFp3KMGquS7PLDiYcOX"
};